<template>
    <filter-wrapper :filterName='settings.name' :expand='expanded'>
        <div class='filter-holder'>
            <q-input v-model='searchText' v-if='settings.searchable' placeholder='Search' @focus="focus=true" @blur="focus=false" dense filled>
                <template v-slot:append>
                    <q-icon name="cancel" v-if="searchText && focus" @click.stop.prevent="searchText = ''" class="cursor-pointer"></q-icon>
                    <q-icon name="search" />
                </template>
            </q-input>
            <q-option-group
                :options="firstFiveItems"
                :type="type"
                :max-height="200"
                :modelValue="modelValue"
                @update:modelValue="updateModelValue"
                >
            </q-option-group>
            <q-slide-transition>
                <div v-show='showAllOptions'>
                    <q-option-group
                        :options="remainingItems"
                        :type="type"
                        :max-height="200"
                        :modelValue="modelValue"
                        @update:modelValue="updateModelValue"
                        >
                    </q-option-group>
                </div>
            </q-slide-transition>
            <q-btn style='width:100%' v-if='filteredItems.length > 5' @click='showAllOptions=!showAllOptions' flat>
                {{ showAllOptions === false ? 'View More' : 'Show Less' }}
            </q-btn>
        </div>
    </filter-wrapper>
</template>

<script setup>
import { ref, defineProps, onMounted, computed, defineEmits, watch } from 'vue'
import FilterWrapper from './FilterWrapper.vue'

const props = defineProps({
    settings: {
        type: Object,
        default: () => ({})
    },
    type: {
        type: String,
        default: 'checkbox'
    },
    modelValue: {
        type: [String, Array, Object]
    },
    expanded: {
        type: Boolean,
        default: false,
    }
})
const emit = defineEmits(['update:modelValue'])
let selections = props.type == 'checkbox'? ref([]) : ref('')
const focus = ref(false)

watch(() => props.modelValue, (newValue) => {
    // selections.value = props.type == 'checkbox'? newValue : newValue?.value
    
    // const record = filteredItems.value.find(i => i.value == newValue || i == newValue)
    // let data = record
    // if (!Object.prototype.toString.call(props.modelValue)) data = record.value  
    // selections.value = data    
    if (!newValue) {
        selections.value = ''
    }
})

let items = ref([])
let searchText = ref('')
let showAllOptions = ref(false)

onMounted(() => {
    props.settings.items.forEach(item => {
        const isString = typeof item === 'string'
        const label = isString ? item : item.label
        const value = isString ? item : item.value
        items.value.push({label, value})
    })
})

const filteredItems = computed(() => {
    if (!searchText.value) {
        return items.value
    }
    return items.value.filter(item => item.label.toLowerCase().includes(searchText.value.toLowerCase()))
})

const firstFiveItems = computed(() => {
    return filteredItems.value.slice(0, 5)
})

const remainingItems = computed(() => {
    return filteredItems.value.slice(5)
})

const updateModelValue = (value) => {
    let data = []
    selections.value = value
    if (Array.isArray(value)) {
        value.forEach(item => {
            const record = filteredItems.value.find(i => i.value == item)
            record && data.push({...record, ...{key: props.settings.key}})
        })
    } else {
        const record = filteredItems.value.find(i => i.value == value)
        record && data.push({...record, ...{key: props.settings.key}})
    }
    emit('update:modelValue', value, data)
}

</script>

<style lang='scss' scoped>
    .filter-holder {
        padding: 0 12px 10px 12px;
    }
</style>